module.exports = __webpack_public_path__ + "static/media/14.1b4fc9be.png";